<template>
  <tk-global :components="components"></tk-global>
</template>
<script>
import snackBar from './snackbar.vue'
import confirm from './confirm.vue'
import viewImage from './viewImage.vue'
import dialogForm from './dialogForm'
export default {
  name: 'global',
  data: function () {
    return {
      components: [
        {
          name: 'alert',
          component: snackBar
        }, {
          name: 'confirm',
          component: confirm
        }, {
          name: 'viewImage',
          component: viewImage
        }, {
          name: 'dialogForm',
          component: dialogForm
        }
      ]
    }
  }
}
</script>
